import { memo } from 'react'
import { MatchInfoProps } from '@sport1/types/web'
import LibInfoList, { InfoListProps as LibInfoListProps } from '@sport1/news-styleguide/InfoList'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import CardHeadline from '@sport1/news-styleguide/CardHeadline'

type InfoListProps = Pick<MatchInfoProps, 'headline' | 'infos'> & {
    testID?: string
} & Pick<LibInfoListProps, 'isRightColumn'>

const MatchInfos = ({ infos, testID, isRightColumn }: InfoListProps) => (
    <NonFlexingContainer>
        <NonFlexingContainer marginBottom="spacing-6">
            <CardHeadline
                testID="team-info-headline"
                cardHeadlineType={['cardHeadlineS', 'cardHeadlineM', 'cardHeadlineM']}
                text="INFOS"
            />
        </NonFlexingContainer>
        <NonFlexingContainer
            testID={testID}
            marginBottom="spacing-9"
            backgroundColor="pearl"
            paddingX={['spacing-6', 'spacing-6', 'spacing-6', 'spacing-none']}
        >
            <LibInfoList
                testID={`${testID}-list`}
                isRightColumn={isRightColumn}
                items={infos}
                fontSize="font-size-5"
                lineHeight="lineHeight-24"
            />
        </NonFlexingContainer>
    </NonFlexingContainer>
)

export default memo(MatchInfos)
